<template>
  <div>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>学习成绩查询</el-breadcrumb-item>
        <el-breadcrumb-item>学术英语</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card>
        <el-button @click="getThrough">成绩总揽</el-button>
        <el-table ref="multipleTable" :data="CorrectList" border show-overflow-tooltip="true" tooltip-effect="dark"
          style="width: 100%">

          <!-- <el-table-column
      type="selection"
      width="55"
    >
    </el-table-column> -->


          <el-table-column prop="studentClass" :show-overflow-tooltip="true" label="班级" width="180">
          </el-table-column>

          <el-table-column prop="studentName" label="学生姓名" width="180">
          </el-table-column>
          <el-table-column prop="performance" label="分数" width="180">
          </el-table-column>
          <el-table-column prop="topic" label="作业名称" width="220">
          </el-table-column>
          <!-- <el-table-column
      prop="topic"
      label="作业名称"
      width="220">
    </el-table-column> -->
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="showEnglishEchars(scope.row)"><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-chakan2"></use>
                </svg></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible" destroy-on-close width="80%">
        <ViewEnglishEcharts :EnglshData="EnglshData"></ViewEnglishEcharts>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="showThrough" width="80%" v-if="showThrough" destroy-on-close>
        <ViewScoreEcharts :CorrectList="CorrectList"></ViewScoreEcharts>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showThrough = false">取 消</el-button>
          <el-button type="primary" @click="showThrough = false">确 定</el-button>
        </span>
      </el-dialog>


    </div>
  </div>
</template>

<script>
import ViewEnglishEcharts from '@/components/work/student/ViewEnglishEcharts.vue'
import ViewScoreEcharts from '@/components/work/student/ViewScoreEcharts.vue'

export default {
  components: { ViewEnglishEcharts, ViewScoreEcharts },
  data() {
    return {
      infoList: [],
      CorrectList: [],
      UserResult: {},
      dialogVisible: false,
      showThrough: false,
      EnglshData: {},
    }
  },
  created() {
    this.getCorrectById()
  },
  methods: {
    getCorrectById() {

      this.axios.post("/user/getUserByID", "userid=" + JSON.parse(localStorage.getItem('user')).userid)
        .then(resp => {
          if (resp.data.status == 1) {
            this.axios.post("excell/getThroughByUserid", "studentNumert=" + resp.data.result.studentID)
              .then(resp => {
                if (resp.data.status == 1) {
                  console.log(resp.data.result)
                  this.CorrectList = resp.data.result
                }
              })
          }
        })


    }, showEnglishEchars(data) {
      this.dialogVisible = true
      this.EnglshData = data
    },
    getThrough() {
      this.showThrough = true
    },
  }

}
</script>

<style>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/work/student/CheckEnglish.vue